module.exports = __webpack_public_path__ + "static/img/08@2x.eaa27e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/08@2x.png
// module id = +3pC
// module chunks = 1